<template lang="pug">
  b-modal#updateCMSB(
    ref="updateCMSB"
    :title="$t('ui.combine.update_commission')"
    centered
    no-fade
    no-close-on-backdrop
    :busy="loading"
    size="md"
    @ok="done"
    @show="reset"
    @shown="shown"
    :hide-footer="!$helpers.getVisible(editLimit) || isDisabled"
  )
    b-form#cmForm(novalidate :disabled="!submission.success" @submit.stop.prevent="submit")
      span #[b {{ $t("ui.account_id") + " : " + accountId.toUpperCase() }}]
      #tblModal.table-sm.table-responsive.commission
        table.table.table-bordered
          tbody
            tr(v-show="this.$helpers.isAgentLevel()")
              th {{ comm_sportsbook_hdp_packages_title }}
              td
                b-form-select(
                  ref="comm_sportsbook_hdp_packages"
                  :class="{ 'is-invalid': $v.comm_sportsbook_hdp_packages.$dirty == true && $v.comm_sportsbook_hdp_packages.$error == true, 'is-valid': $v.comm_sportsbook_hdp_packages.$dirty == true && $v.comm_sportsbook_hdp_packages.$error == false }"
                  lazy-formatter=false
                  :options="comm_sportsbook_hdp_packages_options"
                  v-model="$v.comm_sportsbook_hdp_packages.$model"
                  size="sm"
                  :disabled="!$helpers.getVisible(editLimit) || isDisabled"
                )
            tr(v-if="show('A')")
              th {{ comm_sportsbook_hdp_a_title }}
              td
                PTSelect(
                  ref="comm_sportsbook_hdp_a"
                  :dirty="$v.comm_sportsbook_hdp_a.$dirty"
                  :error="$v.comm_sportsbook_hdp_a.$error"
                  :options="comm_sportsbook_hdp_a_options"
                  v-model="$v.comm_sportsbook_hdp_a.$model"
                  :disabled="!$helpers.getVisible(editLimit) || isDisabled"
                )
            //- tr(v-if="show('B')")
            //-   th {{ comm_sportsbook_hdp_b_title }}
            //-   td
            //-     PTSelect(
            //-       ref="comm_sportsbook_hdp_b"
            //-       :dirty="$v.comm_sportsbook_hdp_b.$dirty"
            //-       :error="$v.comm_sportsbook_hdp_b.$error"
            //-       :options="comm_sportsbook_hdp_b_options"
            //-       v-model="$v.comm_sportsbook_hdp_b.$model"
            //-       :disabled="!$helpers.getVisible(editLimit)"
            //-     )
            //- tr(v-if="show('C')")
            //-   th {{ comm_sportsbook_hdp_c_title }}
            //-   td
            //-     PTSelect(
            //-       ref="comm_sportsbook_hdp_c"
            //-       :dirty="$v.comm_sportsbook_hdp_c.$dirty"
            //-       :error="$v.comm_sportsbook_hdp_c.$error"
            //-       :options="comm_sportsbook_hdp_c_options"
            //-       v-model="$v.comm_sportsbook_hdp_c.$model"
            //-       :disabled="!$helpers.getVisible(editLimit)"
            //-     )
            //- tr(v-if="show('D')")
            //-   th {{ comm_sportsbook_hdp_d_title }}
            //-   td
            //-     PTSelect(
            //-       ref="comm_sportsbook_hdp_d"
            //-       :dirty="$v.comm_sportsbook_hdp_d.$dirty"
            //-       :error="$v.comm_sportsbook_hdp_d.$error"
            //-       :options="comm_sportsbook_hdp_d_options"
            //-       v-model="$v.comm_sportsbook_hdp_d.$model"
            //-       :disabled="!$helpers.getVisible(editLimit)"
            //-     )
            //- tr(v-if="show('E')")
            //-   th {{ comm_sportsbook_hdp_e_title }}
            //-   td
            //-     PTSelect(
            //-       ref="comm_sportsbook_hdp_e"
            //-       :dirty="$v.comm_sportsbook_hdp_e.$dirty"
            //-       :error="$v.comm_sportsbook_hdp_e.$error"
            //-       :options="comm_sportsbook_hdp_e_options"
            //-       v-model="$v.comm_sportsbook_hdp_e.$model"
            //-       :disabled="!$helpers.getVisible(editLimit)"
            //-     )
            //- tr(v-if="show('F')")
            //-   th {{ comm_sportsbook_hdp_f_title }}
            //-   td
            //-     PTSelect(
            //-       ref="comm_sportsbook_hdp_f"
            //-       :dirty="$v.comm_sportsbook_hdp_f.$dirty"
            //-       :error="$v.comm_sportsbook_hdp_f.$error"
            //-       :options="comm_sportsbook_hdp_f_options"
            //-       v-model="$v.comm_sportsbook_hdp_f.$model"
            //-       :disabled="!$helpers.getVisible(editLimit)"
            //-     )
            //- tr(v-if="show('G')")
            //-   th {{ comm_sportsbook_hdp_g_title }}
            //-   td
            //-     PTSelect(
            //-       ref="comm_sportsbook_hdp_g"
            //-       :dirty="$v.comm_sportsbook_hdp_g.$dirty"
            //-       :error="$v.comm_sportsbook_hdp_g.$error"
            //-       :options="comm_sportsbook_hdp_g_options"
            //-       v-model="$v.comm_sportsbook_hdp_g.$model"
            //-       :disabled="!$helpers.getVisible(editLimit)"
            //-     )
            //- tr(v-if="show('H')")
            //-   th {{ comm_sportsbook_hdp_h_title }}
            //-   td
            //-     PTSelect(
            //-       ref="comm_sportsbook_hdp_h"
            //-       :dirty="$v.comm_sportsbook_hdp_h.$dirty"
            //-       :error="$v.comm_sportsbook_hdp_h.$error"
            //-       :options="comm_sportsbook_hdp_h_options"
            //-       v-model="$v.comm_sportsbook_hdp_h.$model"
            //-       :disabled="!$helpers.getVisible(editLimit)"
            //-     )
            tr(v-if="show('I')")
              th {{ comm_sportsbook_hdp_i_title }}
              td
                PTSelect(
                  ref="comm_sportsbook_hdp_i"
                  :dirty="$v.comm_sportsbook_hdp_i.$dirty"
                  :error="$v.comm_sportsbook_hdp_i.$error"
                  :options="comm_sportsbook_hdp_i_options"
                  v-model="$v.comm_sportsbook_hdp_i.$model"
                  :disabled="!$helpers.getVisible(editLimit) || isDisabled"
                )
            tr(v-if="show('J')")
              th {{ comm_sportsbook_hdp_j_title }}
              td
                PTSelect(
                  ref="comm_sportsbook_hdp_j"
                  :dirty="$v.comm_sportsbook_hdp_j.$dirty"
                  :error="$v.comm_sportsbook_hdp_j.$error"
                  :options="comm_sportsbook_hdp_j_options"
                  v-model="$v.comm_sportsbook_hdp_j.$model"
                  :disabled="!$helpers.getVisible(editLimit) || isDisabled"
                )
            tr
              th {{ comm_sportsbook_1x2_title }}
              td
                PTSelect(
                  ref="comm_sportsbook_1x2"
                  :dirty="$v.comm_sportsbook_1x2.$dirty"
                  :error="$v.comm_sportsbook_1x2.$error"
                  :options="comm_sportsbook_1x2_options"
                  v-model="$v.comm_sportsbook_1x2.$model"
                  :disabled="!$helpers.getVisible(editLimit) || isDisabled"
                )
            tr
              th {{ comm_sportsbook_others_title }}
              td
                PTSelect(
                  ref="comm_sportsbook_others"
                  :dirty="$v.comm_sportsbook_others.$dirty"
                  :error="$v.comm_sportsbook_others.$error"
                  :options="comm_sportsbook_others_options"
                  v-model="$v.comm_sportsbook_others.$model"
                  :disabled="!$helpers.getVisible(editLimit) || isDisabled"
                )
      .form-group
        b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import config from "@/config";
import { required, maxValue } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton";
import PTSelect from "@/library/PTSelect";

export default {
  components: {
    PTSelect,
    SubmitButton
  },
  props: {
    accountId: "",
    currency: ""
  },
  data() {
    return {
      loading: false,
      comm_sportsbook_hdp_a: 0,
      comm_sportsbook_hdp_b: 0,
      comm_sportsbook_hdp_c: 0,
      comm_sportsbook_hdp_d: 0,
      comm_sportsbook_hdp_e: 0,
      comm_sportsbook_hdp_f: 0,
      comm_sportsbook_hdp_g: 0,
      comm_sportsbook_hdp_h: 0,
      comm_sportsbook_hdp_i: 0,
      comm_sportsbook_hdp_j: 0,
      comm_sportsbook_1x2: 0,
      comm_sportsbook_others: 0,
      comm_sportsbook_hdp_packages: "",
      cmJSON: {
        hdp_a: 0,
        hdp_b: 0,
        hdp_c: 0,
        hdp_d: 0,
        hdp_e: 0,
        hdp_f: 0,
        hdp_g: 0,
        hdp_h: 0,
        hdp_i: 0,
        hdp_j: 0,
        one_x_two: 0,
        others: 0,
        hdp_packages: ""
      },
      submission: {
        success: true,
        status: ""
      }
    }
  },
  validations: {
    comm_sportsbook_hdp_a: {
      required,
      maxValue(value) {
        return maxValue(this.comm_sportsbook_hdp_a_max)(value)
      }
    },
    comm_sportsbook_hdp_b: {
      required,
      maxValue(value) {
        return maxValue(this.comm_sportsbook_hdp_b_max)(value)
      }
    },
    comm_sportsbook_hdp_c: {
      required,
      maxValue(value) {
        return maxValue(this.comm_sportsbook_hdp_c_max)(value)
      }
    },
    comm_sportsbook_hdp_d: {
      required,
      maxValue(value) {
        return maxValue(this.comm_sportsbook_hdp_d_max)(value)
      }
    },
    comm_sportsbook_hdp_e: {
      required,
      maxValue(value) {
        return maxValue(this.comm_sportsbook_hdp_e_max)(value)
      }
    },
    comm_sportsbook_hdp_f: {
      required,
      maxValue(value) {
        return maxValue(this.comm_sportsbook_hdp_f_max)(value)
      }
    },
    // comm_sportsbook_hdp_g: {
    //   required
    // },
    // comm_sportsbook_hdp_h: {
    //   required
    // },
    comm_sportsbook_hdp_i: {
      required
    },
    comm_sportsbook_hdp_j: {
      required
    },
    comm_sportsbook_1x2: {
      required,
      maxValue(value) {
        return maxValue(this.comm_sportsbook_1x2_max)(value)
      }
    },
    comm_sportsbook_others: {
      required,
      maxValue(value) {
        return maxValue(this.comm_sportsbook_others_max)(value)
      }
    },
    comm_sportsbook_hdp_packages: {
      required
    }
  },
  computed: {
    isDisabled() {
      return this.$helpers.isDisabledField();
    },
    editLimit: function() {
      return [config.accessRoles.editLimit]
    },
    comm_sportsbook_hdp_packages_title: function() {
      return this.$t("ui.hdp_packages")
    },
    comm_sportsbook_hdp_packages_options: function() {
      let packages = this.$store.getters.getCommSBPackages
      let result = []
      if(packages) {
        packages.split(",").forEach((value, index) => {
          result.push({value:value, text:this.$t("ui.combine.comm_limit_" + value)})
        })
      }
      return result
    },
    comm_sportsbook_hdp_a_title: function() {
      return this.$t("ui.hdp") + "/" + this.$t("ui.ou") + "/" + this.$t("ui.oe") + " (" + this.comm_sportsbook_hdp_a_max + ")"
      // return this.$t("ui.combine.comm_limit_A") + " (" + this.comm_sportsbook_hdp_a_max + ")"
    },
    comm_sportsbook_hdp_a_max: function() {
      return this.currency == 'MMK' ? 1 : this.$store.getters.getCommSB('hdp_a')
    },
    comm_sportsbook_hdp_a_options: function() {
      return this.$helpers.getCommRateList1(this.comm_sportsbook_hdp_a_max, this.comm_sportsbook_hdp_a)
    },
    comm_sportsbook_hdp_b_title: function() {
      return this.$t("ui.combine.comm_limit_B") + " (" + this.comm_sportsbook_hdp_b_max + ")"
    },
    comm_sportsbook_hdp_b_max: function() {
      return this.currency == 'MMK' ? 0.5 : this.$store.getters.getCommSB('hdp_b')
    },
    comm_sportsbook_hdp_b_options: function() {
      return this.$helpers.getCommRateList1(this.comm_sportsbook_hdp_b_max, this.comm_sportsbook_hdp_b)
    },
    comm_sportsbook_hdp_c_title: function() {
      return this.$t("ui.combine.comm_limit_C") + " (" + this.comm_sportsbook_hdp_c_max + ")"
    },
    comm_sportsbook_hdp_c_max: function() {
      return this.currency == 'MMK' ? 0.75 : this.$store.getters.getCommSB('hdp_c')
    },
    comm_sportsbook_hdp_c_options: function() {
      return this.$helpers.getCommRateList1(this.comm_sportsbook_hdp_c_max, this.comm_sportsbook_hdp_c)
    },
    comm_sportsbook_hdp_d_title: function() {
      return this.$t("ui.combine.comm_limit_D") + " (" + this.comm_sportsbook_hdp_d_max + ")"
    },
    comm_sportsbook_hdp_d_max: function() {
      return this.currency == 'MMK' ? 1 : this.$store.getters.getCommSB('hdp_d')
    },
    comm_sportsbook_hdp_d_options: function() {
      return this.$helpers.getCommRateList1(this.comm_sportsbook_hdp_d_max, this.comm_sportsbook_hdp_d)
    },
    comm_sportsbook_hdp_e_title: function() {
      return this.$t("ui.combine.comm_limit_E") + " (" + this.comm_sportsbook_hdp_e_max + ")"
    },
    comm_sportsbook_hdp_e_max: function() {
      return this.currency == 'MMK' ? 1.25 : this.$store.getters.getCommSB('hdp_e')
    },
    comm_sportsbook_hdp_e_options: function() {
      return this.$helpers.getCommRateList1(this.comm_sportsbook_hdp_e_max, this.comm_sportsbook_hdp_e)
    },
    comm_sportsbook_hdp_f_title: function() {
      return this.$t("ui.combine.comm_limit_F") + " (" + this.comm_sportsbook_hdp_f_max + ")"
    },
    comm_sportsbook_hdp_f_max: function() {
      return this.currency == 'MMK' ? 1.5 : this.$store.getters.getCommSB('hdp_f')
    },
    comm_sportsbook_hdp_f_options: function() {
      return this.$helpers.getCommRateList1(this.comm_sportsbook_hdp_f_max, this.comm_sportsbook_hdp_f)
    },
    // comm_sportsbook_hdp_g_title: function() {
    //   return this.$t("ui.combine.comm_limit_G") + " (" + this.comm_sportsbook_hdp_g_max + ")"
    // },
    // comm_sportsbook_hdp_g_max: function() {
    //   return this.$store.getters.getCommSB('hdp_g')
    // },
    // comm_sportsbook_hdp_g_options: function() {
    //   return this.$helpers.getCommRateList(this.comm_sportsbook_hdp_g_max)
    // },
    // comm_sportsbook_hdp_h_title: function() {
    //   return this.$t("ui.combine.comm_limit_H") + " (" + this.comm_sportsbook_hdp_h_max + ")"
    // },
    // comm_sportsbook_hdp_h_max: function() {
    //   return this.$store.getters.getCommSB('hdp_h')
    // },
    // comm_sportsbook_hdp_h_options: function() {
    //   return this.$helpers.getCommRateList(this.comm_sportsbook_hdp_h_max)
    // },
    comm_sportsbook_hdp_i_title: function() {
      return this.$t("ui.combine.comm_limit_I") + " (" + this.comm_sportsbook_hdp_i_max + ")"
    },
    comm_sportsbook_hdp_i_max: function() {
      return this.$store.getters.getCommSB('hdp_i')
    },
    comm_sportsbook_hdp_i_options: function() {
      return this.$helpers.getCommRateList(this.comm_sportsbook_hdp_i_max)
    },
    comm_sportsbook_hdp_j_title: function() {
      return this.$t("ui.combine.comm_limit_J") + " (" + this.comm_sportsbook_hdp_j_max + ")"
    },
    comm_sportsbook_hdp_j_max: function() {
      return this.$store.getters.getCommSB('hdp_j')
    },
    comm_sportsbook_hdp_j_options: function() {
      return this.$helpers.getCommRateList(this.comm_sportsbook_hdp_j_max)
    },
    comm_sportsbook_1x2_title: function() {
      return this.$t("ui.oxt") + "/" + this.$t("ui.double_chance") + " (" + this.comm_sportsbook_1x2_max + ")"
    },
    comm_sportsbook_1x2_max: function() {
      return this.currency == 'MMK' ? 0.25 : this.$store.getters.getCommSB('one_x_two')
    },
    comm_sportsbook_1x2_options: function() {
      return this.$helpers.getCommRateList1(this.comm_sportsbook_1x2_max, this.comm_sportsbook_1x2)
    },
    comm_sportsbook_others_title: function() {
      return this.$t("ui.others") + " (" + this.comm_sportsbook_others_max + ")"
    },
    comm_sportsbook_others_max: function() {
      return this.currency == 'MMK' ? 1 : this.$store.getters.getCommSB('others')
    },
    comm_sportsbook_others_options: function() {
      return this.$helpers.getCommRateList1(this.comm_sportsbook_others_max, this.comm_sportsbook_others)
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault()
      this.submit()
    },
    show: function(mode) {
      let result = false
      if(this.$helpers.isAgentLevel()) {
        if (this.comm_sportsbook_hdp_packages == mode){
          result = true
        }
      } else {
        this.comm_sportsbook_hdp_packages.split(",").forEach((value) => {
          if (value == mode){
            result = true
          }
        })
      }
      return result
    },
    getChildCommission: function() {
      $("select").prop("disabled", !this.$helpers.getVisible(this.editLimit))
      $(".pt-field").prop("disabled", this.isDisabled)
      let member_id = this.accountId
      let platform_code = "SPORTSBOOK"
      if(member_id) {
        this.$store
        .dispatch("user/getChildCommission", { member_id, platform_code })
        .then(response => {
          if(!this.$helpers.isAgentLevel()) {
            this.$v.comm_sportsbook_hdp_packages.$model = this.$store.getters.getCommSBPackages
            this.$v.comm_sportsbook_hdp_a.$model = response.data.Table[0].hdp_a
            this.$v.comm_sportsbook_hdp_b.$model = response.data.Table[0].hdp_b
            this.$v.comm_sportsbook_hdp_c.$model = response.data.Table[0].hdp_c
            this.$v.comm_sportsbook_hdp_d.$model = response.data.Table[0].hdp_d
            this.$v.comm_sportsbook_hdp_e.$model = response.data.Table[0].hdp_e
            this.$v.comm_sportsbook_hdp_f.$model = response.data.Table[0].hdp_f

            this.$v.comm_sportsbook_hdp_i.$model = response.data.Table[0].hdp_i
            this.$v.comm_sportsbook_hdp_j.$model = response.data.Table[0].hdp_j
          } else {
            this.$v.comm_sportsbook_hdp_packages.$model = response.data.Table[0].hdp_packages
            this.$v.comm_sportsbook_hdp_a.$model = this.comm_sportsbook_hdp_a_max
            this.$v.comm_sportsbook_hdp_b.$model = this.comm_sportsbook_hdp_b_max
            this.$v.comm_sportsbook_hdp_c.$model = this.comm_sportsbook_hdp_c_max
            this.$v.comm_sportsbook_hdp_d.$model = this.comm_sportsbook_hdp_d_max
            this.$v.comm_sportsbook_hdp_e.$model = this.comm_sportsbook_hdp_e_max
            this.$v.comm_sportsbook_hdp_f.$model = this.comm_sportsbook_hdp_f_max

            this.$v.comm_sportsbook_hdp_i.$model = this.comm_sportsbook_hdp_i_max
            this.$v.comm_sportsbook_hdp_j.$model = this.comm_sportsbook_hdp_j_max
            switch(response.data.Table[0].hdp_packages){
              case "A":
                this.$v.comm_sportsbook_hdp_a.$model = response.data.Table[0].hdp_a
                break
              case "B":
                this.$v.comm_sportsbook_hdp_b.$model = response.data.Table[0].hdp_b
                break
              case "C":
                this.$v.comm_sportsbook_hdp_c.$model = response.data.Table[0].hdp_c
                break
              case "D":
                this.$v.comm_sportsbook_hdp_d.$model = response.data.Table[0].hdp_d
                break
              case "E":
                this.$v.comm_sportsbook_hdp_e.$model = response.data.Table[0].hdp_e
                break
              case "F":
                this.$v.comm_sportsbook_hdp_f.$model = response.data.Table[0].hdp_f
                break
              case "I":
                this.$v.comm_sportsbook_hdp_i.$model = response.data.Table[0].hdp_i
                break
              case "J":
                this.$v.comm_sportsbook_hdp_j.$model = response.data.Table[0].hdp_j
                break
            }
          }
          this.$v.comm_sportsbook_1x2.$model = response.data.Table[0].one_x_two
          this.$v.comm_sportsbook_others.$model = response.data.Table[0].others
          $("select").prop("disabled", !this.$helpers.getVisible(this.editLimit))
          $(".pt-field").prop("disabled", this.isDisabled)
        })
        .catch(response => {
        });
      } else {
        this.cancel()
      }
    },
    submit: function() {
      // this.reset()
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        this.$swal({
          title: this.$t("ui.status"),
          text: this.$t("message.update_account_commission_confirm"),
          type: "warning",
          showCancelButton: true,
          allowOutsideClick: false
        }).then(result => {
          if (result.value) {
            this.updateCommSB()
          } else if (
            // Read more about handling dismissals
            result.dismiss === 'cancel'
          ) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.cancel"),
              text: this.$t("message.update_account_commission_cancel"),
              type: "error"
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        });
      }
    },
    updateCommSB: function() {
      let member_id = this.accountId
      if(!this.$helpers.isAgentLevel()) {
        this.cmJSON.hdp_a = this.comm_sportsbook_hdp_a
      } else {
        let group = this.$refs.comm_sportsbook_hdp_packages.value.toLowerCase()
        let comm = "comm_sportsbook_hdp_" + group
        this.cmJSON.hdp_a = this.$refs[comm].value
      }

      this.cmJSON.hdp_b = this.comm_sportsbook_hdp_b
      this.cmJSON.hdp_c = this.comm_sportsbook_hdp_c
      this.cmJSON.hdp_d = this.comm_sportsbook_hdp_d
      this.cmJSON.hdp_e = this.comm_sportsbook_hdp_e
      this.cmJSON.hdp_f = this.comm_sportsbook_hdp_f
      this.cmJSON.hdp_g = this.comm_sportsbook_hdp_g
      this.cmJSON.hdp_h = this.comm_sportsbook_hdp_h
      this.cmJSON.hdp_i = this.comm_sportsbook_hdp_i
      this.cmJSON.hdp_j = this.comm_sportsbook_hdp_j
      this.cmJSON.one_x_two = this.comm_sportsbook_1x2
      this.cmJSON.others = this.comm_sportsbook_others
      this.cmJSON.hdp_packages = this.comm_sportsbook_hdp_packages
      let cm = this.cmJSON
      this.$store
        .dispatch("user/updateCommissionSB", { member_id, cm })
        .then(response => {
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if(this.submission.success == true) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.succeed"),
              text: this.$t("message.update_account_commission_success"),
              type: "success",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        })
        .catch(response => {
          // console.log("Failed:updateCommissionSB", response)
          this.loading = false;
          if((typeof response.errorTag) != 'object') {
            this.submission.success = response.success
            this.submission.status = this.$t("message." + response.errorTag)
          }
        });
    },
    reset: function() {
      this.submission.success = true
      this.submission.status = ""
      this.comm_sportsbook_hdp_a = 0
      this.comm_sportsbook_hdp_b = 0
      this.comm_sportsbook_hdp_c = 0
      this.comm_sportsbook_hdp_d = 0
      this.comm_sportsbook_hdp_e = 0
      this.comm_sportsbook_hdp_f = 0
      this.comm_sportsbook_hdp_g = 0
      this.comm_sportsbook_hdp_h = 0
      this.comm_sportsbook_hdp_i = 0
      this.comm_sportsbook_hdp_j = 0
      this.comm_sportsbook_1x2 = 0
      this.comm_sportsbook_others = 0
      this.comm_sportsbook_hdp_packages = ""
    },
    shown: function() {
      this.$nextTick(() => {
        this.$v.$reset()
        this.$helpers.getCommission()
        this.getChildCommission()
      });
    },
    cancel: function() {
      // this.$emit("clicked")
      this.$refs.updateCMSB.hide()
    }
  }
};
</script>

